import script from "./ordersInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./ordersInfoList.vue?vue&type=script&setup=true&lang=js"

import "./ordersInfoList.vue?vue&type=style&index=0&id=1fdaa8af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdaa8af"]])

export default __exports__